import {LocalStorageService} from "./localStorageService";
import {StorageKeys} from "../consts/storageKeys.ts";
import {Orientation} from "../consts/orientation.ts";
import {DeviceSize} from "../consts/device.ts";
import {IStorageService} from "./IStorageService.ts";

export interface IAppStateService {
    checkIfIsCookiesAgreed(): boolean | "not set",
    setIsCookiesAgreed(value: boolean | "not set"): void,
}

const VideoQualityLevelPreference = {
    "AUTO": "auto",
    "LOW": "najniższa",
    "BEST": "najlepsza"
} as const;
export type VideoQualityLevelPreference = keyof typeof VideoQualityLevelPreference;

export interface AppState {
    isCookiesAgreed: boolean | "not set";
    qualityLevelPreference: VideoQualityLevelPreference;
}


export class AppStateService implements IAppStateService {
    private readonly _storage: IStorageService;
    private _appState: AppState;

    constructor() {
        this._storage = new LocalStorageService();
        this._appState = this.get();
    }

    get(): AppState {
        const appState = this._storage.getItem<AppState>(StorageKeys.APP_STATE);
        if (appState)
            return appState;
        else
            return {isCookiesAgreed: "not set", qualityLevelPreference: "AUTO"};
    }

    save(): void {
        this._storage.setItem<AppState>(StorageKeys.APP_STATE, this._appState);
    }

    checkIfIsCookiesAgreed(): boolean | "not set" {
        if (this._appState)
            return this._appState.isCookiesAgreed;
        return "not set";
    }

    setIsCookiesAgreed(value: boolean | "not set"): void {
        this._appState.isCookiesAgreed = value;
        this.save();
    }

    setQualityLevelPreference(value: VideoQualityLevelPreference): void {
        this._appState.qualityLevelPreference = value;
        this.save();
    }

    getOrientation(): Orientation {
        const orientation = screen.orientation.type;

        switch (orientation) {
            case "landscape-primary":
                return Orientation.LANDSCAPE_PRIMARY;
            case "landscape-secondary":
                return Orientation.LANDSCAPE_SECONDARY;
            case "portrait-primary":
                return Orientation.PORTRAIT_PRIMARY;
            case "portrait-secondary":
                return Orientation.PORTRAIT_SECONDARY;
            default:
                return Orientation.NONE;
        }
    }

    getDeviceSize(): DeviceSize {
        const windowSize = window.innerWidth;

        if (windowSize <= DeviceSize.mobile)
            return DeviceSize.none;
        if (windowSize > DeviceSize.mobile && windowSize <= DeviceSize.mobileL)
            return DeviceSize.mobile;
        if (windowSize > DeviceSize.mobileL && windowSize <= DeviceSize.tablet)
            return DeviceSize.mobileL;
        if (windowSize > DeviceSize.tablet && windowSize <= DeviceSize.tabletL)
            return DeviceSize.mobileL;
        if (windowSize > DeviceSize.tabletL && windowSize <= DeviceSize.laptop)
            return DeviceSize.tablet;
        if (windowSize > DeviceSize.laptop && windowSize <= DeviceSize.laptopL)
            return DeviceSize.laptop;
        if (windowSize > DeviceSize.laptopL && windowSize <= DeviceSize.desktop)
            return DeviceSize.laptopL;
        if (windowSize > DeviceSize.desktop)
            return DeviceSize.desktop;
        else return DeviceSize.laptop;
    }
}
